<template>
  <div class="demand-detail-page">
    <TopBanner />
    <div class="demand-scroll-area">
      <div class="page-content">
        <!-- 面包屑 -->
        <div style="margin: 13px auto">
          <el-breadcrumb separator=">" style="font-size: 16px">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item @click.native="$router.go(-1)" style="cursor: pointer">信息查看与管理</el-breadcrumb-item>
            <el-breadcrumb-item>需求详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <!-- 竞价人员 -->
        <div class="info-card" style="margin-top: 20px; border-radius: 20px">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">竞价人员: </span>
              <span class="title-count"> 共{{ biddingList.length }}人</span>
            </div>
            <div style="font-weight: 400; font-size: 16px; color: #333333">
              <span>待你审核竞价：</span>
              <span style="color: #ff9318; cursor: pointer" @click="openBiddingDialog">{{ biddingList.length }} 条消息 ></span>
            </div>
          </div>
        </div>

        <!-- 验样人员 -->
        <div class="info-card" style="margin-top: 20px; border-radius: 20px">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">验样人员: </span>
              <span class="title-count"> 共{{ applyList.length }}人</span>
            </div>
            <div style="font-weight: 400; font-size: 16px; color: #333333">
              <span>待你审核验样：</span>
              <span style="color: #ff9318; cursor: pointer" @click="openVerifierDialog">{{ applyList.length }}条消息 ></span>
            </div>
          </div>
        </div>

        <!-- 用户信息卡片 -->
        <div style="margin-top: 20px; border-radius: 16px">
          <div style="height: 10px; background: #ff8801; border-radius: 20px 20px 0px 0px"></div>
          <div class="info-card" style="border-radius: 0px 0px 20px 20px">
            <div class="user-card">
              <div class="user-main">
                <div class="avatar">
                  <img src="@/assets/image/avatar.png" alt="avatar" />
                </div>
                <div class="user-meta">
                  <div class="name-row">
                    <span class="user-name">{{ demand?.appUser?.relationName || "无" }}</span>
                    <div class="status-tag">
                      <span class="status-valid" v-if="demand.demandStatus == 'release'">待验样 / 验样中</span>
                      <span class="status-blue" v-if="demand.demandStatus == 'wait_order'">待发起订单</span>
                      <span class="status-bidding" v-if="demand.demandStatus == 'bidding'">待竞价 / 竞价中</span>
                      <span class="status-blue" v-if="demand.demandStatus == 'completed'">已完成</span>
                      <span class="status-blue" v-if="demand.demandStatus == 'repurchase_bidding'">复购竞价</span>
                      <span class="status-bidding" v-if="demand.demandStatus == 'close'">关闭</span>
                    </div>
                    <span class="user-id">ID：{{ demand.userId }}</span>
                  </div>
                  <div class="role-text">{{ demand?.appUser?.postName || "无" }}</div>
                </div>
              </div>
              <div class="user-contact">
                <div class="contact-item">
                  <img style="width: 18px; height: 18px" src="@/assets/image/iconPhone.png" />
                  <span style="font-size: 18px">{{ demand?.appUser?.relationPhone || "无" }}</span>
                </div>
                <div class="contact-item">
                  <img style="width: 18px; height: 18px" src="@/assets/image/wechat.png" />
                  <span style="font-size: 18px">{{ demand?.appUser?.wxNumber || "无" }}</span>
                </div>
              </div>
            </div>
            <div class="time-row">
              <span>发布时间：{{ demand.releaseTime }}</span>
              <span class="divider">|</span>
              <span>验样截止时间：{{ demand.verifyEndTime }}</span>
            </div>
          </div>
        </div>

        <div style="background: #ffffff; border-radius: 16px; padding: 30px 22px; margin-top: 20px">
          <!-- 基本信息 -->
          <div>
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">基本信息</span>
            </div>
            <div style="margin-top: 24px">
              <div class="product-name">产品名称：{{ demand.productName }}</div>
              <div class="info-row" style="margin-top: 9px; display: block">
                <span class="label">产品分类：{{ demand.productType }}</span>
                <div style="width: 1px; background: #999999; height: 12px; display: inline-block; margin-left: 10px"></div>
                <span class="label" style="margin-left: 10px">质量要求：{{ demand.qualityDemand }}</span>
              </div>
              <div class="info-row remark-row">
                <span class="value">备注：{{ demand.productRemark }}</span>
              </div>
            </div>
          </div>

          <!-- 图片 -->
          <div style="margin-top: 44px">
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">图片</span>
            </div>
            <div class="image-list" v-if="productPictureList.length != 0">
              <div v-for="(img, index) in productPictureList" :key="index" class="image-item">
                <el-image :src="img" :preview-src-list="productPictureList" fit="cover" />
              </div>
            </div>
            <div v-else>无</div>
          </div>

          <!-- 公司信息 -->
          <div style="margin-top: 24px">
            <div class="section-title">
              <span class="title-bar"></span>
              <span class="title-text">公司信息</span>
            </div>
            <div style="margin-top: 10px">
              <div class="info-row">
                <span class="label">公司名称：</span>
                <span class="value">{{ demand?.appUser?.enterpriseName || "无" }}</span>
              </div>
              <div class="info-row" style="margin-top: 4px">
                <span class="label">公司地址：</span>
                <span class="value">{{ demand?.appUser?.address || "无" }}</span>
              </div>
              <div class="info-row" style="margin-top: 4px">
                <span class="label">E-mail：</span>
                <span class="value">{{ demand?.appUser?.mail || "无" }}</span>
              </div>
              <div class="license-row" style="margin-top: 4px">
                <span class="label">营业执照：</span>
                <el-image v-if="invoicePictureList.length > 0" class="license-img" :preview-src-list="invoicePictureList" :src="invoicePictureList[0]"> </el-image>
                <span v-else class="value">暂无</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部申请按钮 -->
      <div class="footer-action">
        <button class="btn-apply btn-a" @click="handleDeleteDemand">删除</button>
        <button class="btn-apply btn-a" v-if="demand.demandStatus == 'release' || demand.demandStatus == 'wait_order' || demand.demandStatus == 'bidding'" @click="openTerminateDialog">
          终止招标
        </button>
        <!-- 还没有供应商提交验样时,隐藏结束验样 -->
        <button class="btn-apply btn-b" v-if="demand.demandStatus == 'release'" @click="openEditDemandDialog">修改需求</button>
        <button class="btn-apply btn-b" v-if="demand.demandStatus == 'release' && applyList.length != 0" @click="finishVerifyEndFun(demand.demandId)">结束验样</button>
        <button class="btn-apply btn-b" v-if="demand.demandStatus == 'wait_order'" @click="openCreateOrderDialog">发起订单</button>
        <button class="btn-apply btn-b" v-if="demand.demandStatus == 'completed'" @click="openCreateOrderDialog">发起复购订单</button>
        <!-- 采购方只能审核竞价,不能修改 -->
        <!-- <button class="btn-apply btn-b" v-if="demand.demandStatus == 'bidding'">修改竞价</button> -->
      </div>
    </div>

    <!-- 提交成功结果弹窗 -->
    <ResultDialog :visible.sync="showResultDialog" title="提交成功" subtitle="请耐心等待采购方确认验样结果" @confirm="showResultDialog = false" @cancel="showResultDialog = false" />

    <!-- 终止招标确认弹窗 -->
    <ResultDialog
      :visible.sync="showTerminateDialog"
      title="终止招标提示"
      subtitle="你确定要终止招标吗？"
      :icon-src="require('@/assets/image/question-mark.png')"
      :dialog-width="'420px'"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="handleTerminateConfirm"
      @cancel="showTerminateDialog = false"
      @close="closeTerminateDialog"
      btnMarginTop="35px"
    >
      <template #default>
        <div style="padding: 0 23px">
          <el-input resize="none" style="font-family: initial; font-size: 16px" type="textarea" :rows="6" placeholder="请输入终止理由" v-model="terminateReason"> </el-input>
        </div>
      </template>
    </ResultDialog>

    <!-- 通过/不通过确认弹窗 -->
    <ResultDialog
      :visible.sync="showConfirmDialog"
      :title="confirmDialogTitle"
      :subtitle="confirmDialogSubtitle"
      :icon-src="require('@/assets/image/question-mark.png')"
      :dialog-width="'420px'"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="handleConfirmAudit"
      @cancel="showConfirmDialog = false"
      @close="closeConfirmDialog"
      btnMarginTop="35px"
    >
      <template #default>
        <div style="padding: 0 23px">
          <div style="background: #f9f9f9; border-radius: 14px; padding: 20px 14px">
            <div class="confirm-slot">
              <img class="confirm-avatar" src="@/assets/image/avatar.png" alt="avatar" />
              <div class="confirm-info">
                <div class="confirm-name" style="color: #666666">{{ rowData.userName || rowData.relationName || "无" }}</div>
                <div class="confirm-company" style="font-size: 12px; color: #999999">{{ rowData.enterpriseName || "无" }}</div>
              </div>
            </div>
            <div style="text-align: left; margin-top: 14px">备注：{{ confirmDialogRemark }}</div>
          </div>
          <el-input resize="none" style="margin-top: 11px; font-family: initial; font-size: 16px" type="textarea" :rows="6" placeholder="请输入理由" v-model="textarea"> </el-input>
        </div>
      </template>
    </ResultDialog>

    <!-- 修改需求弹窗（验样阶段） -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showEditDemandDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showEditDemandDialog = false" />
        <h3 class="publish-title">修改需求</h3>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">产品名称<i class="required-star">*</i></span>
            <el-input v-model="editForm.productName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品分类<i class="required-star">*</i></span>
            <el-select v-model="editForm.productTypeId" placeholder="请选择" class="form-select" @change="editProductTypeChange">
              <el-option v-for="item in productTypeList" :key="item.productTypeId" :label="item.typeName" :value="item.productTypeId" />
            </el-select>
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="editForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">验样时间<i class="required-star">*</i></span>
            <el-date-picker value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" v-model="editForm.verifyEndTime" type="datetime" placeholder="选择截止时间" class="form-date" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">质量要求<i class="required-star">*</i></span>
            <el-input v-model="editForm.qualityDemand" type="textarea" placeholder="请输入" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注</span>
            <el-input :maxlength="1000" show-word-limit v-model="editForm.productRemark" type="textarea" placeholder="说点详细信息吧" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">产品图片<i class="required-star">*</i></span>
            <ImageUpload v-model="editForm.productPicture" multiple :limit="5" dir="product" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">发票图片</span>
            <ImageUpload v-model="editForm.invoicePicture" :multiple="false" size="148px" dir="avatar" />
          </div>
        </div>
        <div style="text-align: center">
          <button class="publish-submit-btn" @click="submitEditDemand">保存修改</button>
        </div>
      </div>
    </el-dialog>

    <!-- 验样人员弹窗 -->
    <el-dialog top="10vh" :append-to-body="true" :visible.sync="showVerifierDialog" width="1200px" :show-close="false" :close-on-click-modal="false" custom-class="verifier-dialog">
      <div class="verifier-modal">
        <div class="verifier-header">
          <div class="verifier-title-wrap">
            <span class="verifier-title-bar"></span>
            <span class="verifier-title-text">验样人员</span>
            <span class="verifier-title-count">(共{{ applyList.length }}人)</span>
          </div>
          <img class="verifier-close-btn" src="@/assets/image/close1-icon.png" @click="showVerifierDialog = false" />
        </div>
        <div class="verifier-list">
          <div class="verifier-item" v-for="(item, index) in applyList" :key="index">
            <div class="verifier-user">
              <img class="verifier-avatar" src="@/assets/image/avatar.png" alt="avatar" />
              <span class="verifier-name">{{ item.relationName || "无" }}</span>
            </div>
            <div class="verifier-company">
              <div>{{ item.enterpriseName }}</div>
              <div class="verifier-contact">
                <div class="verifier-contact-item">
                  <img src="@/assets/image/iconPhone.png" />
                  <span>{{ item.relationPhone || "无" }}</span>
                </div>
                <div class="verifier-contact-item">
                  <img src="@/assets/image/wechat.png" />
                  <span>{{ item.wxNumber || "无" }} </span>
                </div>
              </div>
            </div>

            <div class="verifier-remark">备注：{{ item.applyRemark || "无" }}</div>
            <div style="flex: 0.5">
              <div class="verifier-actions">
                <!-- apply=已申请,pass=通过,not_pass=未通过,close=终止 -->
                <button class="verifier-btn verifier-btn-default" @click="openDetailInfo(item)">查看申请</button>
                <button class="verifier-btn verifier-btn-default" v-show="item.applyStatus == 'apply'" @click="openNotPassDialog(item)">未通过</button>
                <button class="verifier-btn verifier-btn-primary" v-show="item.applyStatus == 'apply'" @click="openPassDialog(item)">通过验样</button>
              </div>
              <div v-show="item.applyStatus == 'not_pass'" style="color: #ff4040; margin-top: 10px">已拒绝，未通过原因：{{ item.auditExplain }}</div>
              <div v-show="item.applyStatus == 'pass'" style="color: #00a63e; margin-top: 10px">验样通过 {{ item.auditExplain }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 竞价人员弹窗 -->
    <el-dialog top="10vh" :append-to-body="true" :visible.sync="showBiddingDialog" width="1200px" :show-close="false" :close-on-click-modal="false" custom-class="verifier-dialog">
      <div class="verifier-modal">
        <div class="verifier-header">
          <div class="verifier-title-wrap">
            <span class="verifier-title-bar"></span>
            <span class="verifier-title-text">竞价人员</span>
            <span class="verifier-title-count">(共{{ biddingList.length }}人)</span>
          </div>
          <img class="verifier-close-btn" src="@/assets/image/close1-icon.png" @click="showBiddingDialog = false" />
        </div>
        <div class="verifier-list">
          <!-- 竞价数据 -->
          <div class="verifier-item" v-for="(item, index) in biddingList" :key="index">
            <div class="verifier-user">
              <img class="verifier-avatar" src="@/assets/image/avatar.png" alt="avatar" />
              <span class="verifier-name">{{ item.userName || "无" }}</span>
            </div>
            <div class="verifier-company">
              <div>{{ item.enterpriseName || "无" }}</div>
              <div class="verifier-contact">
                <div class="verifier-contact-item">
                  <img src="@/assets/image/iconPhone.png" />
                  <span>{{ item.relationPhone || "无" }}</span>
                </div>
                <div class="verifier-contact-item">
                  <img src="@/assets/image/wechat.png" />
                  <span>{{ item.wxNumber || "无" }}</span>
                </div>
              </div>
            </div>
            <div class="verifier-remark">
              <div>备注：{{ item.biddingRemark || "无" }}</div>
            </div>

            <div style="flex: 0.5">
              <div class="verifier-actions">
                <button class="verifier-btn verifier-btn-default" @click="openDetailInfo2(item)">查看申请</button>
                <button class="verifier-btn verifier-btn-default" v-show="item.biddingStatus == 'bidding'" @click="openBiddingNotPassDialog(item)">未通过</button>
                <button class="verifier-btn verifier-btn-primary" v-show="item.biddingStatus == 'bidding'" @click="openBiddingPassDialog(item)">通过竞价</button>
              </div>
              <div v-show="item.biddingStatus == 'not_pass'" style="color: #ff4040; margin-top: 10px">已拒绝，未通过原因：{{ item.auditExplain }}</div>
              <div v-show="item.biddingStatus == 'pass'" style="color: #00a63e; margin-top: 10px">验样通过 {{ item.auditExplain }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 产品需求发布弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showPublishDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleClosePublishDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showPublishDialog = false" />
        <h3 class="publish-title">申请验样</h3>
        <div style="font-weight: 400; font-size: 16px; color: #999999; text-align: center">验样通过后即可参与竞价</div>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">企业名称<i class="required-star">*</i></span>
            <el-input disabled v-model="publishForm.enterpriseName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系人<i class="required-star">*</i></span>
            <el-input v-model="publishForm.relationName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="publishForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">职务<i class="required-star">*</i></span>
            <el-input v-model="publishForm.postName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">微信号</span>
            <el-input v-model="publishForm.wxNumber" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">E-mail</span>
            <el-input v-model="publishForm.mail" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">地址<i class="required-star">*</i></span>
            <el-input v-model="publishForm.address" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注<i class="required-star">*</i></span>
            <el-input v-model="publishForm.applyRemark" type="textarea" placeholder="请输入" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">公司营业执照<i class="required-star">*</i></span>
            <div class="upload-row">
              <div class="upload-box">
                <span class="upload-plus">+</span>
                <span class="upload-text">点击添加</span>
              </div>
            </div>
          </div>
        </div>

        <div style="text-align: center">
          <button class="publish-submit-btn" @click="applyVerifyFun">提交申请</button>
        </div>
      </div>
    </el-dialog>

    <!-- 发起订单弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showCreateOrderDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleCloseCreateOrderDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showCreateOrderDialog = false" />
        <h3 class="publish-title">发起订单</h3>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">产品名称<i class="required-star">*</i></span>
            <el-input v-model="orderForm.productName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品类别<i class="required-star">*</i></span>
            <el-select v-model="orderForm.productTypeId" placeholder="请选择" class="form-select" @change="productTypeIdChange">
              <!-- <el-option v-for="item in productTypes" :key="item.value" :label="item.label" :value="item.value" /> -->
              <el-option v-for="item in productTypeList" :key="item.productTypeId" :label="item.typeName" :value="item.productTypeId" />
            </el-select>
          </div>
          <div class="form-item">
            <span class="form-label">数量</span>
            <el-input type="number" v-model="orderForm.number" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系人</span>
            <el-input v-model="orderForm.relationName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="orderForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">交货期限</span>
            <el-date-picker v-model="orderForm.deliveryTime" type="date" placeholder="请选择" class="form-date" value-format="yyyy-MM-dd" />
          </div>
          <div class="form-item">
            <span class="form-label">付款方式</span>
            <el-input v-model="orderForm.payMethod" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品质量</span>
            <el-input v-model="orderForm.productQuality" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">产品图片</span>
            <ImageUpload v-model="orderForm.productPicture" :multiple="true" :limit="9" size="120px" dir="product" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">订单信息</span>
            <el-input v-model="orderForm.orderInfo" type="textarea" placeholder="请输入订单信息" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注</span>
            <el-input :maxlength="1000" show-word-limit v-model="orderForm.orderRemark" type="textarea" placeholder="说点详细信息吧" class="form-textarea" :rows="4" />
          </div>
          <div v-if="demand.demandStatus == 'completed'" style="text-align: center; color: #ff0000">*将会向本次需求订单通过验样的所有供应商发起复购竞价申请</div>
        </div>

        <div style="text-align: center">
          <button class="publish-submit-btn" @click="submitCreateOrder">发起订单</button>
        </div>
      </div>
    </el-dialog>

    <!-- 验样申请信息弹窗 -->
    <el-dialog top="8vh" :append-to-body="true" :visible.sync="detailInfoDialog" width="808px" :show-close="false" :close-on-click-modal="false" custom-class="publish-demand-dialog">
      <div class="publish-modal" style="padding-bottom: 56px">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="detailInfoDialog = false" />
        <h3 class="publish-title">验样申请信息</h3>
        <div style="color: #ff0000; text-align: center; margin-top: 7px">
          <span v-if="detailInfo.applyStatus == 'apply'">已申请</span>
          <span v-if="detailInfo.applyStatus == 'pass'">通过</span>
          <span v-if="detailInfo.applyStatus == 'not_pass'">未通过</span>
          <span v-if="detailInfo.applyStatus == 'terminate'">终止</span>
        </div>
        <div class="info-pop-box">
          <div class="row-box">
            <div class="row-label">企业名称：</div>
            <div class="row-value">{{ detailInfo.enterpriseName || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">联系人：</div>
            <div class="row-value">{{ detailInfo.relationName || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">联系方式：</div>
            <div class="row-value">{{ detailInfo.relationPhone || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">职务：</div>
            <div class="row-value">{{ detailInfo.postName || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">微信号：</div>
            <div class="row-value">{{ detailInfo.wxNumber || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">E-mail：</div>
            <div class="row-value">{{ detailInfo.mail || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">地址：</div>
            <div class="row-value">{{ detailInfo.address || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">备注：</div>
            <div class="row-value">{{ detailInfo.applyRemark || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">营业执照：</div>
            <div class="row-value">
              <template v-if="detailLicenseList.length > 0">
                <el-image v-for="(item, index) in detailLicenseList" :key="index" class="license-img" :src="item" :preview-src-list="detailLicenseList" fit="cover" />
              </template>
              <span v-else>无</span>
            </div>
          </div>
          <div class="row-box">
            <div class="row-label">审核结果：</div>
            <div class="row-value">{{ detailInfo.auditExplain || "无" }}</div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 竞价申请表单弹窗 -->
    <el-dialog top="8vh" :append-to-body="true" :visible.sync="detailInfoDialog2" width="808px" :show-close="false" :close-on-click-modal="false" custom-class="publish-demand-dialog">
      <div class="publish-modal" style="padding-bottom: 56px">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="detailInfoDialog2 = false" />
        <h3 class="publish-title">竞价申请表单</h3>
        <div style="color: #ff0000; text-align: center; margin-top: 7px">
          <span v-if="detailInfo2.biddingStatus == 'bidding'">已竞价</span>
          <span v-if="detailInfo2.biddingStatus == 'pass'">通过</span>
          <span v-if="detailInfo2.biddingStatus == 'not_pass'">未通过</span>
          <span v-if="detailInfo2.biddingStatus == 'close'">终止</span>
        </div>
        <div class="bidding-detail">
          <div class="detail-item">
            <span class="detail-label">产品名称：</span>
            <span class="detail-value">{{ detailInfo2.productName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">企业名称：</span>
            <span class="detail-value">{{ detailInfo2.enterpriseName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系人：</span>
            <span class="detail-value">{{ detailInfo2.relationName || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">E-mail：</span>
            <span class="detail-value">{{ detailInfo2.mail || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">联系方式：</span>
            <span class="detail-value">{{ detailInfo2.relationPhone || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">地址：</span>
            <span class="detail-value">{{ detailInfo2.address || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">类别：</span>
            <span class="detail-value">{{ detailInfo2.productType || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">数量：</span>
            <span class="detail-value">{{ detailInfo2.number || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">交货期限：</span>
            <span class="detail-value">{{ detailInfo2.deliveryTime || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">单价：</span>
            <span class="detail-value">{{ detailInfo2.price || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">总价：</span>
            <span class="detail-value">{{ detailInfo2.totalAmount || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">付款方式：</span>
            <span class="detail-value">{{ detailInfo2.payMethod || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">产品质量：</span>
            <span class="detail-value">{{ detailInfo2.productQuality || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">备注：</span>
            <span class="detail-value">{{ detailInfo2.biddingRemark || "无" }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">审核结果：</span>
            <span class="detail-value">{{ detailInfo2.auditExplain || "无" }}</span>
          </div>
          <div class="detail-item" style="width: 100%">
            <span class="detail-label">营业执照：</span>
            <span class="detail-value">
              <template v-if="detailProductPictureList.length > 0">
                <el-image v-for="(item, index) in detailProductPictureList" :key="index" class="license-img" :src="item" :preview-src-list="detailProductPictureList" fit="cover" />
              </template>
              <span v-else>无</span>
            </span>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 平台推荐供应商弹窗 -->
    <el-dialog top="8vh" :append-to-body="true" :visible.sync="showRecommendSupplierDialog" width="1000px" :show-close="false" :close-on-click-modal="false" custom-class="recommend-supplier-dialog">
      <div class="recommend-modal">
        <!-- 头部 -->
        <div class="recommend-header">
          <h3 class="recommend-title">平台推荐供应商</h3>
          <p class="recommend-subtitle">这是平台推荐的供应商，你也可以选择向他们发起竞价邀请</p>
          <img class="recommend-close-btn" src="@/assets/image/close1-icon.png" @click="showRecommendSupplierDialog = false" />
        </div>
        <!-- 供应商列表 -->
        <div class="recommend-list">
          <div class="recommend-item" v-for="(item, index) in recommendSupplierList" :key="index" :class="{ 'recommend-item-selected': item.selected }">
            <!-- 复选框 -->
            <div class="recommend-checkbox" @click="toggleSupplierSelect(index)">
              <span v-if="item.selected" class="checkbox-checked">✓</span>
              <span v-else class="checkbox-unchecked"></span>
            </div>

            <div class="recommend-avatar-info">
              <img class="recommend-avatar" :src="item.avatar" alt="avatar" />
              <div class="recommend-name">{{ item.userName || item.createBy || "无" }}</div>
            </div>

            <div class="recommend-info">
              <div class="recommend-company">{{ item.enterpriseName || "无" }}</div>
              <div class="recommend-meta">
                <div class="recommend-meta-item">
                  <img src="@/assets/image/iconPhone.png" />
                  <span>{{ item.relationPhone || "无" }}</span>
                </div>
                <div class="recommend-meta-item">
                  <img src="@/assets/image/wechat.png" />
                  <span>{{ item.wxNumber || "无" }}</span>
                </div>
              </div>
            </div>
            <!-- 查看资料按钮 -->
            <button class="recommend-view-btn" @click="showAsd(item)">查看资料</button>
          </div>
        </div>
        <!-- 底部按钮 -->
        <div class="recommend-footer">
          <button class="recommend-submit-btn" @click="initiateBiddingInvitation">发起竞价邀请</button>
        </div>
      </div>
    </el-dialog>

    <!-- 平台推荐供应商资料弹窗 -->
    <el-dialog top="8vh" :append-to-body="true" :visible.sync="recommendationDialog" width="646px" :show-close="false" :close-on-click-modal="false" custom-class="publish-demand-dialog">
      <div class="publish-modal" style="padding-bottom: 56px; background: none">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="recommendationDialog = false" />
        <h3 class="publish-title">平台推荐供应商资料</h3>
        <div class="info-pop-box">
          <div class="row-box">
            <div class="row-label">企业名称：</div>
            <div class="row-value">{{ recommendationRowData.enterpriseName || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">E-mail：</div>
            <div class="row-value">{{ recommendationRowData.mail || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">地址：</div>
            <div class="row-value">{{ recommendationRowData.address || "无" }}</div>
          </div>
          <div class="row-box">
            <div class="row-label">营业执照：</div>
            <div class="row-value">
              <template v-if="getBusinessLicenseList.length > 0">
                <el-image v-for="(item, index) in getBusinessLicenseList" :preview-src-list="getBusinessLicenseList" :key="index" style="width: 280px; height: 170px; border-radius: 10px" :src="item">
                </el-image>
              </template>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopBanner from "@/components/TopBanner.vue";
import ResultDialog from "@/components/ResultDialog.vue";
import ImageUpload from "@/components/ImageUpload.vue";
import { resolveFileUrl } from "@/utils/oss";
import {
  getDemandDetail,
  applyVerify,
  getApplyVerifyList,
  getApplyVerifyDetail,
  finishVerifyEnd,
  auditApplyVerify,
  closeDemand,
  createDemandOrder,
  getBiddingListByDemand,
  getBiddingDetail,
  auditBidding,
  getReferralsSupplierList,
  inviteSupplier,
  removeDemand,
  getProductTypeList,
  editDemand,
  finishBidding,
} from "@/api/demand";
import { getAppUser } from "@/api/user";
import { getDictData } from "@/api";

export default {
  name: "DemandDetail",
  components: {
    TopBanner,
    ResultDialog,
    ImageUpload,
  },
  data() {
    return {
      recommendationRowData: {
        enterpriseName: "",
        mail: "",
        address: "",
        businessLicense: "",
      },
      loading: false,
      showPublishDialog: false,
      showResultDialog: false,
      detailInfoDialog: false,
      detailInfoDialog2: false,
      detailInfo: {},
      detailInfo2: {},
      userRes: {},
      textarea: "",
      demand: {
        demandId: null,
        demandCode: "",
        userId: null,
        productName: "",
        productType: "",
        relationPhone: "",
        verifyEndTime: "",
        qualityDemand: "",
        productRemark: "",
        productPicture: "",
        invoicePicture: "",
        demandStatus: "",
        releaseTime: "",
        orderCount: 0,
        closeExplain: "",
        delFlag: 1,
        statusGroup: "",
        createBy: "",
        createTime: "",
        updateBy: "",
        updateTime: "",
        remark: "",
      },
      publishForm: {
        demandId: "", //需求id
        enterpriseName: "", //企业名称
        relationName: "", //联系人
        relationPhone: "", //联系电话
        postName: "", //职务名称
        wxNumber: "", //微信号
        mail: "", //邮箱
        address: "", //地址
        applyRemark: "", //申请备注
        businessLicense: "", //营业执照
      },
      applyList: [],
      biddingList: [],
      showVerifierDialog: false,
      showBiddingDialog: false,
      // 终止招标确认弹窗
      showTerminateDialog: false,
      terminateReason: "",
      // 通过/不通过确认弹窗
      showConfirmDialog: false,
      confirmDialogType: "", // 'pass' | 'not_pass'
      confirmDialogSource: "verify", // 'verify' | 'bidding'
      rowData: {},
      // 发起订单弹窗
      showCreateOrderDialog: false,
      orderForm: {
        demandId: "",
        productName: "",
        productType: "",
        productTypeId: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        productPicture: [],
        orderInfo: "",
        orderRemark: "",
      },
      // 平台推荐供应商弹窗
      showRecommendSupplierDialog: false,
      recommendationDialog: false,
      recommendSupplierList: [],
      productTypes: [],
      productTypeList: [],
      showEditDemandDialog: false,
      editForm: {
        demandId: "",
        productName: "",
        productTypeId: "",
        productType: "",
        relationPhone: "",
        verifyEndTime: "",
        qualityDemand: "",
        productRemark: "",
        productPicture: [],
        invoicePicture: "",
      },
    };
  },
  computed: {
    /** 竞价是否仍在进行中 */
    isBiddingActive() {
      return (
        (this.demand.demandStatus === "bidding" || this.demand.demandStatus === "repurchase_bidding") &&
        this.demand.demandOrder &&
        this.demand.demandOrder.orderStatus === "bidding"
      );
    },
    /** 解析推荐供应商营业执照图片列表（逗号分隔） */
    getBusinessLicenseList() {
      if (!this.recommendationRowData?.businessLicense) return [];
      return this.recommendationRowData?.businessLicense.split(",").filter(Boolean);
    },

    /** 解析产品图片列表（逗号分隔） */
    productPictureList() {
      if (!this.demand.productPicture) return [];
      return this.demand.productPicture
        .split(",")
        .filter(Boolean)
        .map((u) => resolveFileUrl(u));
    },
    /** 解析发票/营业执照图片列表（逗号分隔） */
    invoicePictureList() {
      if (!this.demand?.appUser?.businessLicense) return [];
      return this.demand?.appUser?.businessLicense
        .split(",")
        .filter(Boolean)
        .map((u) => resolveFileUrl(u));
    },
    /** 验样详情弹窗营业执照图片列表（逗号分隔） */
    detailLicenseList() {
      if (!this.detailInfo || !this.detailInfo.businessLicense) return [];
      const raw = this.detailInfo.businessLicense;
      const list = Array.isArray(raw) ? raw.filter(Boolean) : String(raw).split(",").filter(Boolean);
      return list.map((u) => resolveFileUrl(u));
    },
    /** 竞价详情弹窗产品图片列表（逗号分隔） */
    detailProductPictureList() {
      if (!this.detailInfo2 || !this.detailInfo2.productPicture) return [];
      const raw = this.detailInfo2.productPicture;
      const list = Array.isArray(raw) ? raw.filter(Boolean) : String(raw).split(",").filter(Boolean);
      return list.map((u) => resolveFileUrl(u));
    },
    /** 确认弹窗标题 */
    confirmDialogTitle() {
      const prefix = this.confirmDialogSource === "bidding" ? "竞价申请" : "验样申请";
      return this.confirmDialogType === "pass" ? `通过${prefix}` : `未通过${prefix}`;
    },
    /** 确认弹窗副标题 */
    confirmDialogSubtitle() {
      const name = this.rowData.userName || this.rowData.relationName || "";
      const action = this.confirmDialogSource === "bidding" ? "竞价" : "验样";
      return this.confirmDialogType === "pass" ? `你确定要通过"${name}"的${action}申请吗？` : `你确定要不通过"${name}"的${action}申请吗？`;
    },
    /** 确认弹窗备注字段 */
    confirmDialogRemark() {
      if (this.confirmDialogSource === "bidding") {
        return this.rowData.biddingRemark || "无";
      }
      return this.rowData.applyRemark || "无";
    },
  },
  watch: {
    "$route.params.id": {
      handler(newId) {
        if (newId) {
          this.fetchDemandDetail();
          this.fetchApplyVerifyList();
          this.fetchBiddingList();
        }
      },
    },
  },
  mounted() {
    this.userRes = JSON.parse(localStorage.getItem("userRes"));
    this.publishForm.enterpriseName = this.userRes.enterpriseName; //企业名称
    this.fetchDemandDetail();
    this.fetchApplyVerifyList();
    this.fetchBiddingList();
    // this.fetchDict();
    this.getProductTypeListFun();
  },
  methods: {
    productTypeIdChange(id) {
      this.productTypeList.forEach((item) => {
        if (item.productTypeId == id) {
          this.orderForm.productType = item.typeName;
        }
      });
    },

    getProductTypeListFun() {
      getProductTypeList().then((res) => {
        this.productTypeList = res.rows;
      });
    },
    /** 获取数据字典 */
    fetchDict() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },
    showAsd(row) {
      this.recommendationDialog = true;
      getAppUser(row.userId).then((res) => {
        this.recommendationRowData = res.data;
      });
    },
    openDetailInfo2(item) {
      const openDetail = () => {
        const biddingId = item.biddingId || item.id;
        getBiddingDetail(biddingId)
          .then((res) => {
            if (res.code == 200) {
              this.detailInfo2 = res.data;
              this.detailInfoDialog2 = true;
            } else {
              this.$message.error(res.msg || "获取竞价详情失败");
            }
          })
          .catch((error) => {
            this.$message.error(error.message || "获取竞价详情失败");
          });
      };

      // 仅「竞价中」的记录需要确认结束竞价；已拒绝/已通过等直接查看
      const needFinishConfirm = this.isBiddingActive && item.biddingStatus === "bidding";
      if (needFinishConfirm) {
        this.$confirm("查看申请后，所有供应商将结束竞价，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const res = await finishBidding(this.demand.demandId);
            if (res.code == 200) {
              await this.fetchDemandDetail();
              openDetail();
            } else {
              this.$message.error(res.msg || "结束竞价失败");
            }
          })
          .catch(() => {});
        return;
      }
      openDetail();
    },
    openEditDemandDialog() {
      this.editForm = {
        demandId: this.demand.demandId,
        productName: this.demand.productName,
        productTypeId: this.demand.productTypeId,
        productType: this.demand.productType,
        relationPhone: this.demand.relationPhone,
        verifyEndTime: this.demand.verifyEndTime,
        qualityDemand: this.demand.qualityDemand,
        productRemark: this.demand.productRemark,
        productPicture: this.productPictureList.slice(),
        invoicePicture: this.demand.invoicePicture || "",
      };
      this.showEditDemandDialog = true;
    },
    editProductTypeChange(id) {
      this.productTypeList.forEach((item) => {
        if (item.productTypeId == id) {
          this.editForm.productType = item.typeName;
        }
      });
    },
    async submitEditDemand() {
      if (!this.editForm.productName || !this.editForm.productName.trim()) {
        this.$message.warning("请填写产品名称");
        return;
      }
      if (!this.editForm.productTypeId) {
        this.$message.warning("请选择产品分类");
        return;
      }
      if (!this.editForm.relationPhone || !/^1[3-9]\d{9}$/.test(this.editForm.relationPhone)) {
        this.$message.warning("请输入正确的联系方式");
        return;
      }
      if (!this.editForm.verifyEndTime) {
        this.$message.warning("请选择验样截止时间");
        return;
      }
      if (!this.editForm.qualityDemand || !this.editForm.qualityDemand.trim()) {
        this.$message.warning("请填写质量要求");
        return;
      }
      if (!this.editForm.productPicture || this.editForm.productPicture.length === 0) {
        this.$message.warning("请上传产品图片");
        return;
      }
      try {
        const payload = {
          ...this.editForm,
          productPicture: Array.isArray(this.editForm.productPicture) ? this.editForm.productPicture.join(",") : this.editForm.productPicture,
        };
        const res = await editDemand(payload);
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.showEditDemandDialog = false;
          this.fetchDemandDetail();
        } else {
          this.$message.error(res.msg || "修改失败");
        }
      } catch (error) {
        this.$message.error(error.message || "修改失败");
      }
    },
    openDetailInfo(item) {
      const applyVerifyId = item.applyVerifyId || item.id;
      getApplyVerifyDetail(applyVerifyId)
        .then((res) => {
          if (res.code == 200) {
            this.detailInfo = res.data;
            this.detailInfoDialog = true;
          } else {
            this.$message.error(res.msg || "获取详情失败");
          }
        })
        .catch((error) => {
          this.$message.error(error.message || "获取详情失败");
        });
    },
    finishVerifyEndFun(demandId) {
      this.$confirm("确定要结束验样吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const res = await finishVerifyEnd(demandId);
          if (res.code == 200) {
            this.$message.success("操作成功");
            this.fetchDemandDetail();
            this.fetchApplyVerifyList();
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.$message.error(error);
        }
      });
    },
    async applyVerifyFun() {
      // 必填字段校验
      const requiredFields = [
        { key: "enterpriseName", label: "企业名称" },
        { key: "relationName", label: "联系人" },
        { key: "relationPhone", label: "联系方式" },
        { key: "postName", label: "职务" },
        { key: "address", label: "地址" },
        { key: "applyRemark", label: "备注" },
      ];
      for (const field of requiredFields) {
        if (!this.publishForm[field.key] || !this.publishForm[field.key].trim()) {
          this.$message.warning(`请填写${field.label}`);
          return;
        }
      }
      if (!/^1[3-9]\d{9}$/.test(this.publishForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      // 公司营业执照校验（字符串或数组形式均兼容）
      const license = this.publishForm.businessLicense;
      const licenseEmpty = Array.isArray(license) ? license.length === 0 : !license || !String(license).trim();
      if (licenseEmpty) {
        this.$message.warning("请上传公司营业执照");
        return;
      }

      try {
        const res = await applyVerify(this.publishForm);
        if (res.code == 200) {
          this.showPublishDialog = false;
          this.showResultDialog = true;
          this.resetPublishForm();
          this.fetchApplyVerifyList();
        } else {
          this.$message.error(res.msg || "申请验样失败");
        }
      } catch (error) {
        console.error("申请验样失败：", error);
        this.$message.error(error.message || "申请验样失败");
      }
    },
    /** 获取需求详情 */
    async fetchDemandDetail() {
      const demandId = this.$route.params.id;
      if (!demandId) {
        this.$message.error("缺少需求ID参数");
        return;
      }
      this.loading = true;
      try {
        const res = await getDemandDetail(demandId);
        if (res && res.data) {
          this.demand = { ...this.demand, ...res.data };
        }
      } catch (error) {
        console.error("获取需求详情失败：", error);
        this.$message.error("获取需求详情失败");
      } finally {
        this.loading = false;
      }
    },
    /** 获取申请验样列表 */
    async fetchApplyVerifyList() {
      const demandId = this.$route.params.id;
      if (!demandId) return;
      try {
        const res = await getApplyVerifyList(demandId);
        if (res.code == 200) {
          this.applyList = res.rows;
        }
      } catch (error) {
        console.error("获取申请验样列表失败：", error);
      }
    },
    /** 获取竞价/报价列表 */
    async fetchBiddingList() {
      const demandId = this.$route.params.id;
      if (!demandId) return;
      try {
        const res = await getBiddingListByDemand(demandId);
        if (res.code == 200) {
          this.biddingList = res.rows || [];
        }
      } catch (error) {
        console.error("获取报价列表失败：", error);
      }
    },
    /** 获取推荐供应商列表 */
    async fetchReferralsSupplierList() {
      const demandId = this.$route.params.id;
      if (!demandId) return;
      try {
        const res = await getReferralsSupplierList(demandId);
        if (res.code == 200) {
          if (res.rows.length == 0) return; // 发起订单之后, 平台推荐供应商为空, 不应该弹框

          this.recommendSupplierList = res.rows.map((item) => ({
            ...item,
            selected: false,
            avatar: item.avatar || require("@/assets/image/avatar.png"),
          }));
          setTimeout(() => {
            // 弹出平台推荐供应商弹窗
            this.showRecommendSupplierDialog = true;
          }, 1000);
        }
      } catch (error) {
        console.error("获取推荐供应商列表失败：", error);
      }
    },
    handleApply() {
      // this.$message.success("申请验样成功");
    },
    openVerifierDialog() {
      this.showVerifierDialog = true;
    },
    /** 打开竞价人员弹窗 */
    openBiddingDialog() {
      this.showBiddingDialog = true;
    },
    /** 打开"通过验样"确认弹窗 */
    openPassDialog(item) {
      this.rowData = item;
      this.confirmDialogType = "pass";
      this.confirmDialogSource = "verify";
      this.showConfirmDialog = true;
    },
    /** 打开"不通过"确认弹窗（验样） */
    openNotPassDialog(item) {
      this.rowData = item;
      this.confirmDialogType = "not_pass";
      this.confirmDialogSource = "verify";
      this.showConfirmDialog = true;
    },
    /** 打开"通过竞价"确认弹窗 */
    openBiddingPassDialog(item) {
      this.rowData = item;
      this.confirmDialogType = "pass";
      this.confirmDialogSource = "bidding";
      this.showConfirmDialog = true;
    },
    /** 打开"不通过竞价"确认弹窗 */
    openBiddingNotPassDialog(item) {
      this.rowData = item;
      this.confirmDialogType = "not_pass";
      this.confirmDialogSource = "bidding";
      this.showConfirmDialog = true;
    },
    closeConfirmDialog() {
      this.textarea = "";
    },
    /** 打开终止招标弹窗 */
    openTerminateDialog() {
      this.terminateReason = "";
      this.showTerminateDialog = true;
    },
    /** 关闭终止招标弹窗 */
    closeTerminateDialog() {
      this.terminateReason = "";
    },
    /** 终止招标 - 确定 */
    async handleTerminateConfirm() {
      if (!this.terminateReason || !this.terminateReason.trim()) {
        this.$message.warning("请输入终止理由");
        return;
      }
      try {
        const res = await closeDemand({
          demandId: this.demand.demandId,
          closeExplain: this.terminateReason,
        });
        if (res.code == 200) {
          this.showTerminateDialog = false;
          this.$message.success("已终止招标");
          this.fetchDemandDetail();
          this.fetchApplyVerifyList();
        } else {
          this.$message.error(res.msg || "操作失败");
        }
      } catch (error) {
        console.error("终止招标失败：", error);
        this.$message.error(error.message || "操作失败");
      }
    },
    /** 确认弹窗 - 确定（验样/竞价审核通用） */
    async handleConfirmAudit() {
      if (this.confirmDialogSource === "bidding") {
        // 竞价审核
        const biddingId = this.rowData.biddingId || this.rowData.id;
        try {
          const res = await auditBidding({
            biddingId: biddingId,
            biddingStatus: this.confirmDialogType,
            auditExplain: this.textarea,
          });
          if (res.code == 200) {
            this.showConfirmDialog = false;
            this.textarea = "";
            this.$message.success(this.confirmDialogType === "pass" ? "已通过竞价" : "已拒绝竞价");
            this.fetchDemandDetail();
            this.fetchApplyVerifyList();
            this.fetchBiddingList();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        } catch (error) {
          console.error("审核竞价失败：", error);
          this.$message.error(error.message || "操作失败");
        }
        return;
      }
      // 验样审核
      const applyVerifyId = this.rowData.applyVerifyId || this.rowData.id;
      try {
        const res = await auditApplyVerify({
          applyVerifyId: applyVerifyId,
          applyStatus: this.confirmDialogType,
          auditExplain: this.textarea,
        });
        if (res.code == 200) {
          this.showConfirmDialog = false;
          this.textarea = "";
          this.$message.success(this.confirmDialogType === "pass" ? "已通过验样" : "已拒绝验样");
          this.fetchDemandDetail();
          this.fetchApplyVerifyList();
          this.fetchBiddingList();
        } else {
          this.$message.error(res.msg || "操作失败");
        }
      } catch (error) {
        console.error("审核验样失败：", error);
        this.$message.error(error.message || "操作失败");
      }
    },
    applyVer() {
      this.publishForm.demandId = this.demand.demandId;
      this.showPublishDialog = true;
    },
    handleClosePublishDialog() {
      this.showPublishDialog = false;
      this.resetPublishForm();
    },
    resetPublishForm() {
      this.publishForm = {
        demandId: "", //需求id
        enterpriseName: this.userRes.enterpriseName, //企业名称
        relationName: "", //联系人
        relationPhone: "", //联系电话
        postName: "", //职务名称
        wxNumber: "", //微信号
        mail: "", //邮箱
        address: "", //地址
        applyRemark: "", //申请备注
        businessLicense: "", // 营业执照
      };
    },
    /** 打开发起订单弹窗 */
    openCreateOrderDialog() {
      this.resetOrderForm();
      this.orderForm.demandId = this.demand.demandId;

      this.orderForm.productName = this.demand.productName || "";
      this.orderForm.productType = this.demand.productType || "";
      this.orderForm.productTypeId = this.demand.productTypeId || "";
      this.orderForm.relationName = this.userRes.relationName || "";
      this.orderForm.relationPhone = this.userRes.relationPhone || "";
      this.showCreateOrderDialog = true;
    },
    /** 关闭发起订单弹窗 */
    handleCloseCreateOrderDialog() {
      this.showCreateOrderDialog = false;
      this.resetOrderForm();
    },
    /** 重置发起订单表单 */
    resetOrderForm() {
      this.orderForm = {
        demandId: "",
        productName: "",
        productType: "",
        productTypeId: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        productPicture: [],
        orderInfo: "",
        orderRemark: "",
      };
    },
    /** 提交发起订单 */
    async submitCreateOrder() {
      // 必填校验
      if (!this.orderForm.productName || !this.orderForm.productName.trim()) {
        this.$message.warning("请填写产品名称");
        return;
      }
      if (!this.orderForm.productTypeId) {
        this.$message.warning("请选择产品类别");
        return;
      }
      if (!this.orderForm.relationPhone || !this.orderForm.relationPhone.trim()) {
        this.$message.warning("请填写联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.orderForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      try {
        // 构建请求参数，number 转为数字类型，多图转为逗号分隔字符串
        const params = {
          ...this.orderForm,
          number: this.orderForm.number ? Number(this.orderForm.number) : undefined,
          productPicture: Array.isArray(this.orderForm.productPicture) ? this.orderForm.productPicture.join(",") : this.orderForm.productPicture,
        };
        const res = await createDemandOrder(params);
        if (res.code == 200) {
          this.showCreateOrderDialog = false;
          this.$message.success("发起订单成功");
          this.resetOrderForm();
          this.fetchDemandDetail();
          this.fetchReferralsSupplierList(); // 拉取推荐供应商列表
        } else {
          this.$message.error(res.msg || "发起订单失败");
        }
      } catch (error) {
        console.error("发起订单失败：", error);
        this.$message.error(error.message || "发起订单失败");
      }
    },
    /** 切换供应商选中状态 */
    toggleSupplierSelect(index) {
      const item = this.recommendSupplierList[index];
      // 使用 $set 兼容对象初始化时未声明 selected 字段的情况，确保响应式
      this.$set(item, "selected", !item.selected);
    },
    /** 发起竞价邀请 */
    async initiateBiddingInvitation() {
      const selectedList = this.recommendSupplierList.filter((item) => item.selected);
      if (selectedList.length === 0) {
        this.$message.warning("请至少选择一个供应商");
        return;
      }
      try {
        const res = await inviteSupplier({
          supplierIds: selectedList.map((item) => item.referralsSupplierId),
          demandId: selectedList[0].demandId,
        });
        if (res.code == 200) {
          this.$message.success(`已向${selectedList.length}个供应商发起竞价邀请`);
          this.showRecommendSupplierDialog = false;
        } else {
          this.$message.error(res.msg || "发起竞价邀请失败");
        }
      } catch (error) {
        console.error("发起竞价邀请失败：", error);
        this.$message.error(error.message || "发起竞价邀请失败");
      }
    },
    /** 删除需求 */
    handleDeleteDemand() {
      this.$confirm("确认是否删除？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await removeDemand(this.demand.demandId);
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.$router.go(-1);
            } else {
              this.$message.error(res.msg || "删除失败");
            }
          } catch (error) {
            this.$message.error(error.message || "删除失败");
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
/* 引入产品需求发布弹窗公共样式 */
@import "~@/assets/css/publish-dialog.css";

/* 验样人员弹窗 */
.verifier-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}
.verifier-dialog .el-dialog__header {
  display: none;
}
.verifier-dialog .el-dialog__body {
  padding: 0;
}
.verifier-dialog .verifier-modal {
  background: #ffffff;
  padding: 16px;
}
.verifier-dialog .verifier-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 18px;
}
.verifier-dialog .verifier-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}
.verifier-dialog .verifier-title-bar {
  display: inline-block;
  width: 6px;
  height: 22px;
  background: #1869ff;
  border-radius: 3px;
}
.verifier-dialog .verifier-title-text {
  font-size: 22px;
  font-weight: 500;
  color: #333;
}
.verifier-dialog .verifier-title-count {
  font-size: 16px;
  color: #999;
}
.verifier-dialog .verifier-close-btn {
  width: 34px;
  height: 34px;
  cursor: pointer;
}
.verifier-dialog .verifier-list {
  max-height: 60vh;
  overflow-y: auto;
}
.verifier-dialog .verifier-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 10px;
  margin-bottom: 16px;
  border: 1px solid #d7d7d7;
}
.verifier-dialog .verifier-item:last-child {
  margin-bottom: 0;
}
.verifier-dialog .verifier-user {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 110px;
  flex-shrink: 0;
}
.verifier-dialog .verifier-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
}
.verifier-dialog .verifier-name {
  font-size: 16px;
  color: #333;
}
.verifier-dialog .verifier-company {
  width: 220px;
  flex-shrink: 0;
  font-size: 16px;
  color: #333;
}
.verifier-dialog .verifier-contact {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.verifier-dialog .verifier-contact-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #666;
}
.verifier-dialog .verifier-contact-item img {
  width: 14px;
  height: 14px;
}
.verifier-dialog .verifier-remark {
  flex: 1;
  font-size: 16px;
  color: #666;
  padding: 0 12px;
}
.verifier-dialog .verifier-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.verifier-dialog .verifier-btn {
  width: 72px;
  height: 28px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}
.verifier-dialog .verifier-btn-default {
  background: #ffffff;
  border: 1px solid #dcdfe6;
  color: #333;
}
.verifier-dialog .verifier-btn-primary {
  background: #1869ff;
  border: 1px solid #1869ff;
  color: #ffffff;
}

/* ===== 平台推荐供应商弹窗 ===== */
.recommend-supplier-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}
.recommend-supplier-dialog .el-dialog__header {
  display: none;
}
.recommend-supplier-dialog .el-dialog__body {
  padding: 0;
}
.recommend-supplier-dialog .recommend-modal {
  background: #ffffff;
  padding: 17px 56px 20px 56px;
}
.recommend-supplier-dialog .recommend-header {
  text-align: center;
  position: relative;
}
.recommend-supplier-dialog .recommend-title {
  font-size: 24px;
  font-weight: 500;
  color: #333333;
}
.recommend-supplier-dialog .recommend-subtitle {
  font-size: 16px;
  color: #333333;
  font-weight: 400;
  margin-top: 7px;
}
.recommend-supplier-dialog .recommend-close-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 34px;
  height: 34px;
  cursor: pointer;
}
.recommend-supplier-dialog .recommend-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 27px;
}
.recommend-supplier-dialog .recommend-item {
  display: flex;
  align-items: center;
  padding: 13px 15px;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  background: #ffffff;
  transition: border-color 0.2s;
}
.recommend-supplier-dialog .recommend-item-selected {
  border-color: #1869ff;
  background: #f5f9ff;
}
.recommend-supplier-dialog .recommend-checkbox {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.recommend-supplier-dialog .checkbox-unchecked {
  display: block;
  width: 22px;
  height: 22px;
  border: 2px solid #dcdfe6;
  border-radius: 4px;
  background: #ffffff;
}
.recommend-supplier-dialog .checkbox-checked {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: #1869ff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}
.recommend-supplier-dialog .recommend-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.recommend-supplier-dialog .recommend-avatar-info {
  display: flex;
  align-items: center;
  flex: 0.3;
  margin-left: 41px;
}
.recommend-supplier-dialog .recommend-info {
  flex: 1;
}
.recommend-supplier-dialog .recommend-name {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  margin-left: 9px;
}
.recommend-supplier-dialog .recommend-company {
  font-size: 16px;
  color: #333333;
  margin-bottom: 8px;
}
.recommend-supplier-dialog .recommend-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 14px;
  color: #666666;
}
.recommend-supplier-dialog .recommend-meta-item {
  display: flex;
  align-items: center;
  gap: 4px;
}
.recommend-supplier-dialog .recommend-meta-item img {
  width: 14px;
  height: 14px;
}
.recommend-supplier-dialog .recommend-view-btn {
  flex-shrink: 0;
  width: 72px;
  height: 28px;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  background: #fff;
  color: #333333;
  font-size: 14px;
  cursor: pointer;
}

.recommend-supplier-dialog .recommend-footer {
  text-align: center;
  margin-top: 36px;
}
.recommend-supplier-dialog .recommend-submit-btn {
  width: 320px;
  height: 52px;
  border: none;
  border-radius: 10px;
  background: #1869ff;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}
.recommend-supplier-dialog .recommend-submit-btn:hover {
  opacity: 0.9;
}
.recommend-supplier-dialog .recommend-submit-btn:active {
  opacity: 0.85;
}
</style>

<style scoped>
.demand-detail-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f0f4fa;
}

.demand-scroll-area {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.page-content {
  max-width: 1200px;
  margin: 0 auto;
}

/* 信息卡片 */
.info-card {
  background: #ffffff;
  padding: 22px 24px;
}

/* 用户信息卡片 */
.user-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-main {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.status-tag {
  display: inline-block;
  border-radius: 4px;
  font-size: 12px;
}
.status-tag .status-valid {
  padding: 4px 8px;
  background: rgba(0, 166, 62, 0.1);
  color: #00a63e;
  border-radius: 4px;
}
.status-tag .status-bidding {
  padding: 2px 8px;
  background: rgba(235, 82, 0, 0.1);
  color: #ff0000;
  border-radius: 4px;
}
.status-tag .status-blue {
  padding: 2px 8px;
  background: #e3edff;
  color: #1869ff;
  border-radius: 4px;
}

.user-id {
  font-size: 12px;
  color: #999;
}

.role-text {
  font-size: 12px;
  color: #999;
}

.time-row {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}

.time-row .divider {
  margin: 0 8px;
}

.user-contact {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: #333;
}

/* 区块标题 */
.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
}

.title-bar {
  display: inline-block;
  width: 6px;
  height: 22px;
  background: #1869ff;
  border-radius: 3px;
}

.title-text {
  font-size: 24px;
  font-weight: 500;
  color: #333;
}

.title-count {
  font-size: 16px;
  color: #999;
  font-weight: 400;
}

.product-name {
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.info-row {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  color: #666;
}

.info-row .label {
  color: #999;
  flex-shrink: 0;
}

.info-row .value {
  color: #333;
}

.remark-row {
  margin-top: 4px;
}

.remark-row .value {
  line-height: 1.6;
}

/* 图片列表 */
.image-list {
  display: flex;
  gap: 10px;
  margin-top: 8px;
}

.image-item {
  width: 134px;
  height: 134px;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.license-row {
  display: flex;
  align-items: flex-start;
}

.license-row .label {
  color: #999;
  font-size: 14px;
  flex-shrink: 0;
}

.license-img {
  width: 280px;
  height: 200px;
  border-radius: 10px;
}

/* 申请列表 */
.apply-list {
  padding-left: 12px;
  margin-top: 7px;
}

.apply-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0 10px 0;
  border-bottom: 1px solid #efefef;
  font-size: 16px;
}

.apply-item .company-name {
  color: #999;
  flex: 1;
}

.apply-item .phone {
  color: #999;
  flex: 1;
  display: flex;
  align-items: center;
}

.apply-item .apply-time {
  color: #999;
  flex: 1;
  text-align: right;
}

/* 底部操作 */
.footer-action {
  gap: 28px;
  padding: 56px 0 40px 0;
  display: flex;
  justify-content: center;
}

.btn-apply {
  width: 270px;
  height: 60px;
  border: 1px solid #ffffff;
  border-radius: 10px;
  font-size: 18px;
  color: #fff;
  margin: 0;
  cursor: pointer;
}

.btn-apply.btn-a {
  background: #ffffff;
  border: 1px solid #1869ff;
  color: #1869ff;
}
.btn-apply.btn-b {
  background: #1869ff;
  border: 1px solid #1869ff;
  color: #ffffff;
}

/* 确认弹窗插槽内容 */
.confirm-slot {
  display: flex;
  align-items: center;
  gap: 3px;
}

.confirm-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.confirm-info {
  text-align: left;
}

/deep/ .el-textarea__inner {
  font-family: initial !important;
  border-radius: 14px;
}

.info-pop-box {
  font-weight: 400;
  margin-top: 35px;
  font-size: 16px;
}
.info-pop-box .row-box {
  display: flex;
  margin-top: 8px;
}

.info-pop-box .row-box:first-child {
  margin-top: 0;
}
.info-pop-box .row-box .row-label {
  color: #999999;
  width: 90px;
  text-align: right;
}
.info-pop-box .row-box .row-value {
  color: #333333;
  padding-left: 10px;
}

/* 竞价申请表单 - 详情信息区 */
.bidding-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  align-content: flex-start;
  margin-top: 35px;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  width: calc(50% - 12px);
}

.detail-label {
  color: #999999;
  width: 80px;
  flex-shrink: 0;
  text-align: right;
}

.detail-value {
  color: #333333;
  padding-left: 8px;
  flex: 1;
  word-break: break-all;
}
</style>
